module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "Composant_3_61",
      "data-name": "Composant 3 – 61",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "60",
      "height": "22.548",
      "viewBox": "0 0 60 22.548"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip-path"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Rectangle_43",
      "data-name": "Rectangle 43",
      "width": "60",
      "height": "22.548",
      "transform": "translate(1531.96 474.282)",
      "fill": "#92ba28"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Groupe_123",
      "data-name": "Groupe 123",
      "transform": "translate(-1531.96 -474.282)",
      "opacity": "0.4"
    }
  }, [_c('g', {
    attrs: {
      "id": "Groupe_25",
      "data-name": "Groupe 25"
    }
  }, [_c('g', {
    attrs: {
      "id": "Groupe_24",
      "data-name": "Groupe 24",
      "clip-path": "url(#clip-path)"
    }
  }, [_c('path', {
    attrs: {
      "id": "Tracé_56",
      "data-name": "Tracé 56",
      "d": "M1586.345,474.283H1537.58a5.617,5.617,0,0,0-5.618,5.617v11.313a5.617,5.617,0,0,0,5.618,5.617h48.765a5.617,5.617,0,0,0,5.617-5.617V479.9a5.617,5.617,0,0,0-5.617-5.617m-31.681,18.483h-7.9l-1.9-3.286-2.107,3.286h-7.9l4.908-6.8-5.117-7.248h8.446l1.769,3.772,1.9-3.772h8.214l-5.16,7.248Zm14.705,0h-13.377V478.714h7.226V487.8h6.151Zm15.546-.927c-1.474.927-3.034,1.222-6.257,1.222a38.585,38.585,0,0,1-7.793-.717v-3.855a48.375,48.375,0,0,0,7.858.675c.63,0,.968-.211.968-.633,0-.358-.232-.484-.99-.484h-1.18c-.568,0-1.832-.084-2.654-.168a4.737,4.737,0,0,1-3.56-1.6,4.281,4.281,0,0,1-.821-2.7,4.418,4.418,0,0,1,1.663-3.708c1.244-.927,3.729-1.453,6.995-1.453a39.342,39.342,0,0,1,7.414.695v4.129a53.727,53.727,0,0,0-5.665-.485h-1.581c-.969,0-1.347.19-1.347.632,0,.359.3.57.779.57l2.527.021a11.547,11.547,0,0,1,3.623.526,3.658,3.658,0,0,1,2.213,3.5,4.549,4.549,0,0,1-2.192,3.834",
      "fill": _vm.color
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7905780","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/icons/XlsExportIcon.vue
// module id = 3351
// module chunks = 0